export { CurrencyBangladeshi as default } from './CurrencyBangladeshi';
